import React, { useEffect, useState } from "react";
import CenteredMessage from "../components/CenteredMessage";
import { useParams } from 'react-router-dom'
import ListadoProductos from "../components/ListadoProductos";
import ApiService from "../ApiService";
import Avatar from "../components/Avatar";
import HiStatsCounter from "../stats/HiStatsCounter";
import Separator from "../components/Separator";
import ModalTexto from "../components/ModalTexto";
import { getToken } from "../LocalStorage";

const Perfil = (props: any) => {
    const {idPerfil, apodo} = useParams();
    console.log('idPerfil:', idPerfil);
    console.log('apodo:', apodo);
    const [productos,setProductos] = useState([]);
    const [userData,setUserData]:any = useState({});
    const [loading, setLoading] = useState(true);

    const [calificaciones, setCalificaciones] = useState([]);

    useEffect(() => {
        let idPerfilNumero = parseInt(idPerfil || '0');
        (new ApiService()).getPerfil(idPerfilNumero).then((data1: any) => {
            console.log(data1);
            setProductos(data1.data?.productos);
            fetchUserData(idPerfilNumero);

        }).catch(err => {
            console.log(err);
            setLoading(false);
        })
    },[]);

    const fetchUserData = (idUsuario: number) => {
        (new ApiService()).getOneUser(parseInt(idPerfil || '0')).then((data1: any) => {
            console.log(data1);
            setUserData(data1.data?.usuario);
            setLoading(false);
        }).catch(err => {
            console.log(err);
            setLoading(false);
        })  
    }

    if ( loading === true){
        return (<CenteredMessage>Cargando...</CenteredMessage>)
    }

    if ( userData === null){
        return (<CenteredMessage>Perfil No Valido</CenteredMessage>)
    }

    const abrirModal = () => {
        const modalTexto = document.querySelector("#modalTexto") as HTMLDialogElement;
        if (modalTexto)
            modalTexto.showModal();
    }

    const cargarCalificaciones = () => {
        const token = getToken() || '';
        const idPerf = idPerfil || '-1';
        (new ApiService()).getCalificacionesUsuario(token, parseInt(idPerf), 0).then((data1:any)=> {
            if ( data1.err == 0){
                setCalificaciones(data1.data.listado);
                abrirModal();
            }else{
                alert("Ha ocurrido un error");
            }
        }).catch(err => {

        });
    }

    const convertirCalifAString = (calif: number) => {
        switch(calif){
            case 1: return <div style={{color: 'green'}}>Positivo</div>;
            case 0: return <div style={{color: 'yellow'}}>Neutral</div>;
            case -1: return <div style={{color: 'red'}}>Negativo</div>;
            default: return <div style={{color: 'red'}}>Error</div>;
            
        }
    }

    const ItemCalificacion = (item:any) => {
        console.log("item:", item.item);
        return  <div>
                    <div className="flexRow" style={{gap: 10,}}>
                        <b style={{width: '80%'}}>{item.item?.comentario}</b>
                        <b>{convertirCalifAString(item.item?.voto)}</b>
                    </div>
                    <hr/>
                </div>
    }

    return (<div className="flexColumn">
                <div className="flexRow" style={{alignItems: 'stretch', justifyItems: 'center', alignSelf: 'center', width: '80%',
                    backgroundColor: 'lightblue', gap: 20,

                }}>
                    <Avatar pathImagen={userData?.pathRel} />
                    <div className="flexColumn">
                        <h2>Perfil de {userData?.apodo}</h2>
                        <h3 onClick={() => {
                            cargarCalificaciones();
                        }}>Reputacion: {userData?.reputacion} (ver)</h3>
                        <h3>Miembro hace {diff2Dates( userData?.created ,new Date().toString()) + " dias"}</h3>
                    </div>
                </div>
                <Separator separacion ="10"/>
                {(productos.length === 0)?
                    <h3>El usuario no publico nada todavia.</h3>
                :null}
                <ListadoProductos productos={productos} />
                <HiStatsCounter />
                <ModalTexto>
                    <h2>Ultimas Calificaciones</h2>
                    {(calificaciones?.length === 0)?
                        <b>Nadie lo califico todavia</b>
                    :null}

                    {(calificaciones?.length > 0)?<div className="flexColumn">
                        <div>
                            <div className="flexRow" style={{gap: 10,}}>
                                <b>Comentario</b>
                                <b>Calificacion</b>
                            </div>
                            <hr/>
                        </div>
                        {(calificaciones?.map((item:any) => {
                            return <ItemCalificacion key={"calif_" + item.id} item={item} />
                        }))}
                    </div>
                    :null
                    }
                    
                </ModalTexto>
            </div>    
    )
}

function diff2Dates(strFecha1: string, strFecha2: string){
    const fecha1 = new Date(strFecha1);
    const fecha2 = new Date(strFecha2);
    //const differenceInMsExplicit = fecha2.getTime() - fecha1.getTime(); 
    const msPerDay = 1000 * 60 * 60 * 24;
    const differenceInDays = Math.round(Math.abs(fecha2.getTime() - fecha1.getTime()) / msPerDay);

    console.log("Differencia dias:", differenceInDays);
    return differenceInDays;
}

export default Perfil;